import { render, staticRenderFns } from "./PwaApprTableContainer.vue?vue&type=template&id=abb0f58c&"
import script from "./PwaApprTableContainer.vue?vue&type=script&lang=js&"
export * from "./PwaApprTableContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports